import { createAsyncHelper } from "./AsyncHelper";

export function combine(helperMap) {
  const actions = {};
  const state = {};
  const reducerList = [];

  Object.keys(helperMap).forEach((name) => {
    let helper = helperMap[name];
    if (typeof helper === "function") {
      helper = helper({
        // @ts-ignore
        async: (...args) => createAsyncHelper(name, ...args),
      });
    }
    actions[name] = helper.action;
    Object.assign(state, helper.state);
    reducerList.push(helper.reducer);
  });

  return {
    actions,
    reducer: mergeReducers(state, reducerList),
  };
}

// 合并多个 reducer，使其可重复对同一个 state 做不同操作
function mergeReducers(initialState, reducers) {
  return (state = initialState, action) => {
    reducers.forEach((reducer) => {
      state = reducer(state, action);
    });
    return state;
  };
}
